import request from '../servises/blogRequest'

export function getPosts(params) {


    return request({
        url: `posts`,
        method: 'GET',
        params: params
    })
}

export function getPost(params) {
    return request({
        url: `posts/${params}`,
        method: 'GET'
    })
}

export function updatePost(params) {
    params.formData.append('_method','PUT')

    return request({
        url: `posts/${params.postId}`,
        method: 'POST',
        data: params.formData
    })
}

export function createPost(params) {
    return request({
        url: `posts`,
        method: 'POST',
        data: params.formData
    })
}

export function deletePost(params) {
    return request({
        url: `posts/${params}`,
        method: 'DELETE'
    })
}